var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "page-integrations" },
      on: {
        "!click": function ($event) {
          return _vm.checkEmailValidationBeforeIntegration.apply(
            null,
            arguments
          )
        },
      },
    },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [{ title: _vm.$t("message.integrations") }],
          select: true,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "integration-nav" }, [
        _c("div", { staticClass: "big-title" }, [
          _vm._v(_vm._s(_vm.$t("message.allIntegrations"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav-items" },
          _vm._l(_vm.integrationGroups, function (group, index) {
            return _c(
              "a",
              {
                key: index,
                staticClass: "nav-item",
                class: { active: _vm.activeGroup === group.id },
                attrs: { href: "#" + group.id },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.scrollToGroup(group.id)
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "material-icons",
                    style: { color: group.color },
                  },
                  [_vm._v(_vm._s(group.icon))]
                ),
                _vm._v(
                  "\n                    " +
                    _vm._s(group.title) +
                    "\n                "
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex right-page",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            { staticClass: "pl-3 mt-3", staticStyle: { flex: "0 0 100%" } },
            [
              _c(
                "div",
                {
                  staticClass: "integration-group",
                  attrs: { id: "social-media" },
                },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.socialMedia")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _vm.multiWhatsapp &&
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["integrations.whatsapp.view"].tr.name
                    ) &&
                    _vm.istWhatsappV2()
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "story whatsapp-story disabled-integration",
                          },
                          [
                            _c("div", { staticClass: "dead-badge" }, [
                              _vm._v("Dead"),
                            ]),
                            _vm._v(" "),
                            _vm.whatsappV2ChannelExists
                              ? _c("div", { staticClass: "status" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v(" done ")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("message.installationOK")) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "compare-button",
                                on: { click: _vm.openWhatsappComparison },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("compare"),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.integrationsPage.compare")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "img whatsapp" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "material-icons star-v2" },
                                  [_vm._v(" star ")]
                                ),
                                _vm._v(" "),
                                _c("WhatsappV2", {
                                  staticStyle: { width: "40px" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.integrationsPage.whatsappV2Web"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("message.integrationsWhatsappV2")
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story whatsapp-story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/whatsapp-v3")
                          },
                        },
                      },
                      [
                        _vm.whatsappV3ChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "compare-button",
                            on: { click: _vm.openWhatsappComparison },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("compare"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.integrationsPage.compare")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img whatsapp" },
                          [
                            _c("WhatsappV3Icon", {
                              staticStyle: { width: "40px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.whatsappV3QR")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("message.integrationsWhatsappV2")) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["integrations.whatsapp.view"].tr.name
                    )
                      ? _c(
                          "div",
                          {
                            staticClass: "story whatsapp-story",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push(
                                  "integrations/whatsapp-business-api"
                                )
                              },
                            },
                          },
                          [
                            _vm.whatsappBusinessChannelExists
                              ? _c("div", { staticClass: "status" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v(" done ")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("message.installationOK")) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "compare-button",
                                on: { click: _vm.openWhatsappComparison },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("compare"),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.integrationsPage.compare")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "img whatsapp" },
                              [
                                _c("WhatsappBusinessIcon", {
                                  staticStyle: { width: "50px" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.integrationsPage.whatsappBusinessAPI"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.integrationsWhatsappBusiness"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["integrations.whatsapp.view"].tr.name
                    )
                      ? _c(
                          "div",
                          {
                            staticClass: "story",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push("integrations/waba")
                              },
                            },
                          },
                          [
                            _vm.supsisWhatsappBusinessChannelExists
                              ? _c("div", { staticClass: "status" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v(" done ")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("message.installationOK")) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "img whatsapp" },
                              [
                                _c("WhatsappBusinessIcon", {
                                  staticStyle: { width: "50px" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.integrationsPage.whatsappBusinessAPIv2"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.integrationsWhatsappBusiness"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/instagram")
                          },
                        },
                      },
                      [
                        _vm.instagramChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img instagram" },
                          [_c("InstagramIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.instagram"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("message.integrationsInstagram")) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story instagram-v2-story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/instagram-v2")
                          },
                        },
                      },
                      [
                        _vm.instagramV2ChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img instagram" },
                          [_c("InstagramIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.instagramV2")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "message.integrationsPage.instagramV2Desc"
                                )
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/messenger")
                          },
                        },
                      },
                      [
                        _vm.messengerChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img messenger" },
                          [_c("FacebookIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.messenger"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("message.messengerIntegrationDesc")
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/linkedin")
                          },
                        },
                      },
                      [
                        _vm.linkedinChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img linkedin" },
                          [_c("LinkedinIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.linkedin"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("message.integrationsLinkedin")) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/telegram-qr")
                          },
                        },
                      },
                      [
                        _vm.telegramChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img telegram" },
                          [_c("TelegramIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.telegramQR")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("message.integrationsTelegram")) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["integrations.telegram.view"].tr.name
                    )
                      ? _c(
                          "div",
                          {
                            staticClass: "story",
                            on: {
                              click: function () {
                                return _vm.telegramEnabled
                                  ? _vm.createTelegramChannel()
                                  : _vm.$feature.beforeCreateIntegrationChannel(
                                      _vm.createTelegramChannel,
                                      "telegram"
                                    )
                              },
                            },
                          },
                          [
                            _vm.telegramEnabled
                              ? _c("div", { staticClass: "status" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v(" done ")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("message.installationOK")) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a-modal",
                              {
                                attrs: {
                                  title: _vm.$t("telegram.telegramTokenTitle"),
                                  wrapClassName: "vertical-center-modal",
                                  visible: _vm.integrateTelegramModalVisible,
                                },
                                on: {
                                  cancel: function ($event) {
                                    return _vm.handleCancel()
                                  },
                                  ok: function ($event) {
                                    return _vm.handleOk()
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col mb-5" },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "telegram.typeInTelegramToken"
                                          ),
                                        },
                                      },
                                      [
                                        _c(
                                          "a-modal",
                                          {
                                            attrs: {
                                              title: _vm.$t(
                                                "telegram.telegramAlertTitle"
                                              ),
                                            },
                                            on: {
                                              ok: _vm.confirmDeleteToken,
                                              cancel: _vm.cancelDeleteToken,
                                            },
                                            model: {
                                              value: _vm.visibleDeleteToken,
                                              callback: function ($$v) {
                                                _vm.visibleDeleteToken = $$v
                                              },
                                              expression: "visibleDeleteToken",
                                            },
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "telegram.telegramAlertText"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "row mb-3" },
                                          [
                                            _c("a-input", {
                                              staticClass: "mt-2",
                                              class: {
                                                "err-class": _vm.showWarning,
                                              },
                                              staticStyle: { width: "90%" },
                                              attrs: {
                                                autofocus: "",
                                                placeholder:
                                                  _vm.$t("telegram.token"),
                                              },
                                              on: {
                                                change:
                                                  _vm.onTelegramTokenChange,
                                              },
                                              model: {
                                                value: _vm.tempToken,
                                                callback: function ($$v) {
                                                  _vm.tempToken = $$v
                                                },
                                                expression: "tempToken",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _vm.isThereTempToken
                                              ? _c("a-button", {
                                                  staticClass: "ml-2 p-10 mt-2",
                                                  attrs: {
                                                    type: "primary",
                                                    icon: "delete",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.showDeleteConfirmation,
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-alert",
                                      {
                                        attrs: {
                                          "show-icon": "",
                                          type: "info",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "description" },
                                            slot: "description",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "telegram.telegramAlertForm"
                                                  )
                                                ) +
                                                "\n                                            "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "https://t.me/BotFather",
                                                  target: "_blank",
                                                },
                                              },
                                              [_vm._v("BotFather")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "img telegram" },
                              [_c("TelegramIcon")],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.integrationsPage.telegramBotFather"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("message.integrationsTelegram")
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/youtube-comments"
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.youtubeChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img youtube" },
                          [_c("YouTubeIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.youtubeComments")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsYouTubeComments")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/google-business-reviews"
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.googleBusinessChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img google-business" },
                          [_c("GoogleBusinessIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrationsPage.googleBusinessReviews"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrationsGoogleBusinessReviews"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/google-play-reviews"
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.googlePlayChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img google-play" },
                          [_c("GooglePlayIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrationsPage.googlePlayReviews"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsGooglePlayReviews")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/appstore-reviews"
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.appStoreChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img appstore" },
                          [_c("AppStoreIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.appStoreReviews")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsAppStoreReviews")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/google-drive")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.googleDriveChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img google-drive" },
                          [_c("GoogleDriveIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.googleDrive")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsGoogleDrive"))
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "web" } },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.web")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "/integrations/webchat/bubble-settings"
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "status" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" done "),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.installationOK")) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img supsis" },
                          [_c("SupsisIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("message.chatWidget"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("message.integrationsWebchat")) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/integrations/webhook")
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "img webhooks" },
                          [_c("WebhookIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("message.webhooks"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "message.integrateSupsiswithIntegratable",
                                  { integratable: "Webhooks" }
                                )
                              ) +
                              " .\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/integrations/webtabs")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.webTabs"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("message.integrationsPage.webTabsDesc")
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/integrations/webapps")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.webApps"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("message.integrationsPage.webAppsDesc")
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "email" } },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.email")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _vm.isEmailFeatureEnabled()
                      ? _c(
                          "div",
                          {
                            staticClass: "story",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push("integrations/mail")
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "img mail" },
                              [_c("DynamicSvg", { attrs: { name: "Mail" } })],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("message.integrationsPage.mail"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.integrateSupsiswithIntegratable",
                                      { integratable: "Mail" }
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "sms" } },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.sms")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/sms/postacell"
                            )
                          },
                        },
                      },
                      [
                        _vm.smsChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.smsPostacell")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsSMSPostacell"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/sms/netgsm")
                          },
                        },
                      },
                      [
                        _vm.smsNetgsmChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.smsNetgsm"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsSMSNetgsm"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/sms/posta-guvercini"
                            )
                          },
                        },
                      },
                      [
                        _vm.smsPostaGuverciniChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrationsPage.smsPostaGuvercini"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsSMSPostaGuvercini")
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "crm" } },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.crm")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/zoho")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.zohoChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img ideasoft" },
                          [_c("ZohoIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.zohoCRM"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(_vm._s(_vm.$t("message.integrationsZoho"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        staticStyle: { display: "none" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/teamgram")
                          },
                        },
                      },
                      [
                        _vm.teamgramChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img teamgram" },
                          [_c("TeamGramIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.teamgram"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsTeamgram"))
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "integration-group",
                  attrs: { id: "e-commerce" },
                },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.ecommerce")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/ideasoft")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.ideasoftChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img ideasoft" },
                          [_c("IdeasoftIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.ideasoft"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsIdeasoft"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/ticimax")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.ticimaxChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(5),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.ticimax"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(_vm._s(_vm.$t("message.integrationsTicimax"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/integrations/ticimax-v2")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.ticimaxChannelsV2.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(6),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.ticimaxV2"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.ticimaxV2Desc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/trendyol")
                          },
                        },
                      },
                      [
                        _vm.trendyolChannelExists.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img" },
                          [_c("TrendyolIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("message.trendyol"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsTrendyol"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/t-soft")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.tsoftChannelExists.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "img" }, [_c("TsoftIcon")], 1),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.tsoft"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("message.integrationsPage.tsoftDesc")
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/ikas")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.ikasChannelExists.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "img",
                            staticStyle: { background: "#deff37" },
                          },
                          [_c("IkasIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.ikas"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("message.integrationsPage.ikasDesc")
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "integration-group",
                  attrs: { id: "utilities" },
                },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.utilities")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/integrations/webhook")
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "img webhooks" },
                          [_c("WebhookIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("message.webhooks"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "message.integrateSupsiswithIntegratable",
                                  { integratable: "Webhooks" }
                                )
                              ) +
                              " .\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/cache-manager")
                          },
                        },
                      },
                      [
                        _vm._m(7),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.cacheManager")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "message.integrationsPage.cacheManagerDesc"
                                )
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/openai")
                          },
                        },
                      },
                      [
                        _vm.openaiChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img" },
                          [_c("OpenaiIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.openai"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("message.integrationsOpenAI"))
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: { click: _vm.showSlackIntegration },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.slackChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img slack" },
                          [_c("SlackIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [_vm._v("Slack")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("integrations.slackCardDescription")
                              ) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("SlackIntegrationModal", {
                          attrs: {
                            modalVisible: _vm.slackIntegrationModalVisible,
                          },
                          on: {
                            close: function ($event) {
                              _vm.slackIntegrationModalVisible = false
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: { click: _vm.showPushoverIntegration },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.pushoverChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img pushover" },
                          [_c("PushoverIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.pushover"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("integrations.pushoverCardDescription")
                              ) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("PushoverIntegrationModal", {
                          attrs: {
                            modalVisible: _vm.pushoverIntegrationModalVisible,
                          },
                          on: {
                            close: function ($event) {
                              _vm.pushoverIntegrationModalVisible = false
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story story--chrome-ext",
                        on: {
                          click: function ($event) {
                            _vm.chromeExtModalVisible = true
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "badge-free" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.free"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "badge-new" }, [
                          _vm._v("NEW"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "img chrome-ext" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "44",
                                height: "44",
                                viewBox: "0 0 24 24",
                                fill: "#25D366",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.chromeExtTitle")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.chromeExtDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "/integrations/copilot-prompts"
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "img copilot-prompts" },
                          [
                            _c("CopilotPromptsIcon", {
                              staticStyle: { width: "40px", height: "40px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.copilotPrompts")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrationsPage.copilotPromptsDesc"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "integration-group",
                  attrs: { id: "advertising" },
                },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.advertising")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/meta-leads")
                          },
                        },
                      },
                      [
                        _vm.metaLeadsChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img meta" },
                          [_c("MetaIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.metaLeads"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsMetaLeads"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/meta-insights"
                            )
                          },
                        },
                      },
                      [
                        _vm.metaInsightsChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img meta" },
                          [_c("MetaIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.metaInsights")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsMetaInsights"))
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "ses" } },
                [
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("message.integrationsPage.voice"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "stories" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "story",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/integrations/webphone/redsantral"
                              )
                            },
                          },
                        },
                        [
                          _vm.webphoneChannelExists
                            ? _c("div", { staticClass: "status" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v(" done "),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("message.installationOK")) +
                                    "\n                            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(8),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.integrationsPage.webphoneRedsantral"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.integrationsPage.webphoneRedsantralDesc"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "story",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/integrations/webphone/telnyx"
                              )
                            },
                          },
                        },
                        [
                          _vm.telnyxChannelExists
                            ? _c("div", { staticClass: "status" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v(" done "),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("message.installationOK")) +
                                    "\n                            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(9),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.integrationsPage.webphoneTelnyx"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.integrationsPage.webphoneTelnyxDesc"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "story",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/integrations/webphone/netgsm"
                              )
                            },
                          },
                        },
                        [
                          _vm.netgsmChannelExists
                            ? _c("div", { staticClass: "status" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v(" done "),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("message.installationOK")) +
                                    "\n                            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(10),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.integrationsPage.webphoneNetgsm"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.integrationsPage.webphoneNetgsmDesc"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.get"] } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "story",
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push(
                                    "integrations/voice-agent"
                                  )
                                },
                              },
                            },
                            [
                              _vm.retellChannelExists
                                ? _c("div", { staticClass: "status" }, [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v(" done ")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("message.installationOK")
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "img retell" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("record_voice_over"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.integrationsPage.aiVoiceAgent"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.integrationsPage.aiVoiceAgentDesc"
                                      )
                                    ) +
                                    "\n                                "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-modal",
                {
                  attrs: {
                    visible: _vm.chromeExtModalVisible,
                    footer: null,
                    width: 720,
                    "body-style": { padding: 0 },
                    "wrap-class-name": "chrome-ext-modal",
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.chromeExtModalVisible = false
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "chrome-ext-modal__inner" },
                    [
                      _c(
                        "a-carousel",
                        {
                          attrs: {
                            arrows: "",
                            "dots-class": "chrome-ext-modal__dots",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "prevArrow",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "carousel-arrow carousel-arrow--prev",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons" },
                                        [_vm._v("chevron_left")]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "nextArrow",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "carousel-arrow carousel-arrow--next",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons" },
                                        [_vm._v("chevron_right")]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _vm._v(" "),
                          _vm._l(_vm.chromeExtImages, function (img, i) {
                            return _c(
                              "div",
                              {
                                key: i,
                                staticClass: "chrome-ext-modal__slide",
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: img,
                                    alt: "Supsis WhatsApp Extension " + (i + 1),
                                  },
                                }),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "chrome-ext-modal__body" }, [
                        _c("div", { staticClass: "chrome-ext-modal__header" }, [
                          _c("div", { staticClass: "chrome-ext-modal__icon" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "32",
                                  height: "32",
                                  viewBox: "0 0 24 24",
                                  fill: "#25D366",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z",
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "chrome-ext-modal__title" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.integrationsPage.chromeExtTitle"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "chrome-ext-modal__subtitle" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.integrationsPage.chromeExtSubtitle"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "chrome-ext-modal__lead" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.chromeExtLead")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "chrome-ext-modal__features" },
                          _vm._l(_vm.chromeExtFeatures, function (feat, i) {
                            return _c("li", { key: i }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(_vm._s(feat.icon)),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("strong", [_vm._v(_vm._s(feat.title))]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(feat.desc))]),
                              ]),
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "chrome-ext-modal__setup" }, [
                          _c(
                            "div",
                            { staticClass: "chrome-ext-modal__setup-title" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.integrationsPage.chromeExtSetupTitle"
                                  )
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("ol", [
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.integrationsPage.chromeExtStep1"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.integrationsPage.chromeExtStep2"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.integrationsPage.chromeExtStep3"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "chrome-ext-modal__cta",
                            attrs: {
                              href: "https://chromewebstore.google.com/detail/supsis-whatsapp-panel/chibdpbliekjfakffkfihdbinclcgkih",
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "20",
                                  height: "20",
                                  viewBox: "0 0 24 24",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "message.integrationsPage.chromeExtCta"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "ai" } },
                [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.artificialIntelligence") ||
                          _vm.$t(
                            "message.integrationsPage.artificialIntelligenceFallback"
                          )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/openrouter"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("openrouter")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(11),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.openRouter")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.openRouterDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/openai"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("openai")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(12),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.openai"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.openAIDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/google"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("google")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(13),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.googleAIStudio")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrationsPage.googleAIStudioDesc"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/anthropic"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("anthropic")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(14),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.anthropic"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.anthropicDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/mistral"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("mistral")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(15),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.mistral"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.mistralDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/azure"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("azure")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(16),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.microsoftAzure")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrationsPage.microsoftAzureDesc"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/bedrock"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("bedrock")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(17),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.amazonBedrock")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrationsPage.amazonBedrockDesc"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/cohere"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("cohere")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(18),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.cohere"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.cohereDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/xai"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("xai")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(19),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.xai"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.xaiDesc"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/deepinfra"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("deepinfra")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(20),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.deepInfra"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.deepInfraDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/together"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("together")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(21),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.together"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.togetherDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/fireworks"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("fireworks")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(22),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.fireworks"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.fireworksDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/siliconflow"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("siliconflow")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(23),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.siliconFlow")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.siliconFlowDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/parasail"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("parasail")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(24),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.parasail"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.parasailDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/nebius"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("nebius")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(25),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.nebius"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.nebiusDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/alibaba"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("alibaba")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(26),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.alibabaCloud")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrationsPage.alibabaCloudDesc"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/xiaomi"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("xiaomi")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(27),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.xiaomi"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.xiaomiDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/sambanova"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("sambanova")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(28),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.sambaNova"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.sambaNovaDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/moonshot"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("moonshot")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(29),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.moonshotAI")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.moonshotAIDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/minimax"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("minimax")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(30),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.minimax"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.minimaxDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/openrouter/nvidia"
                            )
                          },
                        },
                      },
                      [
                        _vm.getOpenRouterChannelByProvider("nvidia")
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(31),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsPage.nvidia"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.integrationsPage.nvidiaDesc")
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "custom-modal whatsapp-comparison-modal",
          attrs: {
            visible: _vm.whatsappComparisonModalVisible,
            "cancel-text": null,
            width: 1400,
            footer: false,
            "footer-hide": true,
            title: _vm.$t("message.integrationsPage.whatsappComparisonTitle"),
          },
          on: {
            "update:visible": function ($event) {
              _vm.whatsappComparisonModalVisible = $event
            },
            ok: function () {
              return (_vm.whatsappComparisonModalVisible = false)
            },
            cancel: function ($event) {
              _vm.whatsappComparisonModalVisible = false
            },
          },
        },
        [_c("WhatsappComparison")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img webtabs" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("tab")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img webapps" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("web")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img postacell" }, [
      _c("img", { attrs: { src: "/static/img/postacell-logo.png" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img postacell" }, [
      _c("img", { attrs: { src: "/static/img/netgsm-logo.svg" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img postacell" }, [
      _c("img", { attrs: { src: "/static/img/posta-guvercini-logo.png" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ticimax" }, [
      _c("div", { staticClass: "img postacell" }, [
        _c("img", { attrs: { src: "/static/img/ticimax.png" } }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ticimax" }, [
      _c("div", { staticClass: "img postacell" }, [
        _c("img", { attrs: { src: "/static/img/ticimax.png" } }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img cache" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("storage")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img webphone" }, [
      _c(
        "span",
        { staticClass: "material-icons", staticStyle: { color: "#d32f2f" } },
        [_vm._v("phone")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img telnyx" }, [
      _c("img", {
        staticStyle: { width: "40px", height: "40px" },
        attrs: { src: "/static/img/telnyx.png", alt: "Telnyx" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img netgsm" }, [
      _c("img", {
        staticStyle: { width: "40px", height: "40px" },
        attrs: { src: "/static/img/netgsm.png", alt: "NetGSM" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/openrouter.svg",
          alt: "OpenRouter",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/openai.svg",
          alt: "OpenAI",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/google.svg",
          alt: "Google AI",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/anthropic.svg",
          alt: "Anthropic",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/mistral.webp",
          alt: "Mistral",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/microsoft.svg",
          alt: "Microsoft Azure",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/aws.svg",
          alt: "Amazon Bedrock",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/cohere.svg",
          alt: "Cohere",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/xai.svg",
          alt: "xAI",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/deepinfra.webp",
          alt: "DeepInfra",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/togetherai.svg",
          alt: "Together",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/fireworks.svg",
          alt: "Fireworks",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/siliconflow.png",
          alt: "SiliconFlow",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/parasail.svg",
          alt: "Parasail",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/nebius.svg",
          alt: "Nebius",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/alibaba.svg",
          alt: "Alibaba Cloud",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/xiaomi.svg",
          alt: "Xiaomi",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/sambanova.webp",
          alt: "SambaNova",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/moonshot.svg",
          alt: "Moonshot AI",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/minimax.svg",
          alt: "Minimax",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ai-provider" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/ai/nvidia.svg",
          alt: "NVIDIA",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }